<script>
	// Stores
	import MarketStore from '@/Stores/Sport/MarketStore.js';
	// Components
	import Switch from '@/Components/Switch.svelte';
	// Services
	import { notify } from '@/Services/Notify.js';

	export let market;

	let boostableChecked = market && market.boostable;

	function updateBoostable() {
		MarketStore.updateMarketBoostable(market.id, boostableChecked)
			.then(() => {
				notify({
					type: 'success',
					title: `${market.name}`,
					message: `Boost Up for Market updated to ${boostableChecked ? 'On' : 'Off'}`,
					timeout: 3
				});
			})
			.catch(() => {
				boostableChecked = !boostableChecked;
				notify({
					type: 'danger',
					title: `${market.name}`,
					message: 'Failed to update Boost Up',
					timeout: 3
				});
			});
	}
</script>

<div class="flex items-center justify-between">
	<div class="text-xs font-semibold uppercase">Boost Up</div>
	<Switch
		on:change={updateBoostable}
		name={`boost-market-${market.id}`}
		bind:checked={boostableChecked}
		small={true}
		className=""
	/>
</div>
